import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import FooterNav from "@/pages/Other/FooterNav";
import Banner from "./Banner";
import ReasonsToJoin from "./ReasonSmikLearn";
import CareerOpportunities from "./CareerOpportunities";
import LifeAtSmik from "./LifeAtSmik";
import EmployeesSpeak from "./EmployeeSpeak";
import JoinOurteam from "./Joinourteam";
import Disclaimer from "./Disclaimer";
import Navbar from "../About/Navbar";


function CareersPage() {

  return(
    <div>
       <FooterNav />
       <Navbar />
       <Banner />
       <ReasonsToJoin />
       <CareerOpportunities />
       <LifeAtSmik  />
      {/*  <EmployeesSpeak /> */}
       <JoinOurteam />
       <Disclaimer />
    </div>
  );
}

export default CareersPage;